<template>
  <div class="signature-resume">
    <div class="pb-4">
      <h4 v-if="showDetails">Resumo</h4>

      <div class="items">
        <template v-if="showDetails">
          <div class="item">
            <div class="description">Plano {{ selectedPlan?.title }}</div>
            <div class="price">R$ {{ fullPrice.toFixed(2) }}</div>
          </div>

          <div v-if="coupon" class="item">
            <div class="description">
              Desconto cupom {{ coupon.discount_type === 'percentage' ? `(-${coupon.discount_value.replace('.00', '')}%)` : '' }}
            </div>
            <div class="price discount">-R$ {{ discountText }}{{ coupon.recurrency === 'MONTHLY' ? '/mês' : '' }}</div>
          </div>

          <div v-if="cycle === 'YEARLY' && annualDiscount && totalPrice" class="item">
            <div class="description">Desconto anual</div>
            <div class="price discount">-R$ {{ annualDiscount.toFixed(2) }}</div>
          </div>

          <div class="divider"></div>
        </template>

        <div class="item">
          <div class="description">Total</div>
          <div class="price">R$ {{ totalPrice.toFixed(2) }}</div>
        </div>
      </div>
    </div>

    <div v-if="!!this.$slots.checkTerm" class="mb-2">
      <slot name="checkTerm" />
    </div>

    <div v-if="!!this.$slots.actions" class="actions">
      <slot name="actions" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'SignatureResume',
  props: {
    showDetails: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('Payment', ['selectedPlan', 'cycle', 'coupon', 'paymentMethod', 'totalPrice']),
    fullPrice() {
      const price = this.coupon?.signature_price?.price || this.selectedPlan?.price;

      if (this.cycle === 'YEARLY') return price * 12;

      return price;
    },
    discountText() {
      if (!this.coupon) return '';

      if (this.coupon.discount_type === 'percentage') {
        return (this.fullPrice * (this.coupon?.discount_value / 100)).toFixed(2);
      }

      return `${Number(this.coupon?.discount_value)?.toFixed(2) ?? 0}`;
    },
    annualDiscount() {
      return this.coupon?.signature_price?.annual_discount || this.selectedPlan?.annual_discount;
    }
  }
};
</script>
<style lang="scss">
.signature-resume {
  color: #3f505f;
  flex-grow: 1;
  .actions {
    display: flex;
    gap: 12px;

    button {
      flex: 1 1 0;
      flex-grow: 1;
      border-radius: 8px;
      padding: 8px 24px !important;
    }
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .item {
    font-size: 14px;
    display: flex;

    .description {
      flex-grow: 1;
    }

    .price {
      font-weight: 500;

      &.discount {
        color: #e8663d;
      }
    }
  }
}
</style>
